import React, { useState } from 'react';

function analyzeBrief(text) {
  const words = text.trim().split(/\s+/).filter(w => w.length > 0).length;
  if (words === 0)  return { level:-1, phasesLit:0,  bar:0,   label:'',               color:'#E2E8F0' };
  if (words < 6)   return { level:0,  phasesLit:1,  bar:10,  label:'Initialising',    color:'#BFDBFE' };
  if (words < 16)  return { level:1,  phasesLit:4,  bar:36,  label:'Signal acquired', color:'#1A6AFF' };
  if (words < 36)  return { level:2,  phasesLit:7,  bar:66,  label:'Strong brief',    color:'#1A6AFF' };
  if (words < 65)  return { level:3,  phasesLit:10, bar:86,  label:'Excellent',       color:'linear-gradient(90deg,#1A6AFF,#06B6D4)' };
  return               { level:4,  phasesLit:10, bar:100, label:'Exceptional',     color:'linear-gradient(90deg,#1A6AFF,#06B6D4)' };
}

const PHASES = [
  'Nomenclature','Brand DNA','Company Identity','Visual Architecture',
  'Brand Messaging','Strategic Positioning','Customer Experience',
  'Digital Presence','Go-To-Market','Launch and Activation',
];

const LOGO_PATH = "M1738.97 674.63c90.78,-4.22 183.48,27.17 251.43,104.4 15.94,18.13 41.91,69.3 1.62,72.16 -46.02,3.27 -88.76,-125.46 -251.31,-116.94 -114.81,6.03 -237.3,86.41 -251.16,229.53 -1.93,19.95 0.62,68.54 -33.13,68.9 -29.35,0.32 -33.64,-33.32 -33.64,-56.16 -0,-174.72 155.08,-294.4 316.2,-301.89zm114.25 144.02c47.75,27.89 78.37,70.83 93.94,123.44 13.66,46.13 14.63,94.59 4.24,123.39 -10.33,28.65 -55.47,20.8 -55.57,-6.74 -0.26,-75.01 -3.67,-164.23 -88.44,-191.35 -48.39,-15.48 -100.32,1.85 -148.54,8.5 -25.39,3.5 -43.85,-31.11 -23.74,-50.24 45.47,-43.25 164.09,-38.55 218.1,-7.01zm-14.55 333.77c-7,166.5 -53.94,185.3 -78.63,170.78 -21.44,-12.62 -11.51,-37.15 -0.76,-64.82 28.36,-72.98 -15.04,-249.87 46.72,-250.26 46.83,-0.3 33.71,119.34 32.66,144.3zm-121.88 -156.07c-9.32,51.34 18.25,152.91 -38.33,154.46 -47.31,-4.36 -22.81,-48.24 -20.17,-106.83 1.84,-40.62 -6.2,-77.37 17.12,-105.02 26.9,-31.91 98.28,-42.1 104.03,0.05 6.44,47.22 -52.81,3.14 -62.65,57.33zm314.19 -566.85l-561.94 0c-159.7,0 -290.36,130.67 -290.36,290.36l0 560.29c0,159.7 130.67,290.36 290.36,290.36l561.94 0c159.7,0 290.36,-130.67 290.36,-290.36l0 -560.29c0,-159.7 -130.67,-290.36 -290.36,-290.36zm-455.62 789.69c-9.88,24.52 -22.66,37.91 -37.16,34.49 -37.44,-8.83 -26.27,-63.83 -18.13,-91.01 18.44,-61.61 17,-75.47 13.24,-125.89 -4.53,-60.75 9.89,-130.66 49.18,-127.92 23.23,1.62 28.87,15.8 28.42,28.18 -0.78,21.37 -17.34,55.06 -18.04,96.04 -1.02,59.72 8.02,122.74 -17.51,186.11zm311.8 -12.58c3.61,-30.19 1.67,-52.98 15.57,-56.77 18.56,-5.07 42.56,-2.65 44.17,19.27 1.62,21.97 -0.66,42.51 -2.24,59.5 -3.87,41.59 -12.09,67.59 -45.35,62.49 -44.91,-6.88 -14.98,-60.73 -12.15,-84.49zm-432.99 -118.89c17.43,0 31.55,14.13 31.55,31.56 0,17.43 -14.13,31.55 -31.55,31.55 -17.43,0 -31.56,-14.13 -31.56,-31.55 0,-17.43 14.13,-31.56 31.56,-31.56zm236.11 150.43c0.51,39.89 -16.95,103.01 -53.06,82.76 -24.94,-13.99 -10.91,-44.76 -4.19,-66.24 9.98,-31.89 20.3,-47.06 40.38,-42.39 14.26,3.31 16.68,10.73 16.87,25.86zm323.94 -245.56c-3.41,-35.22 -4.16,-71.05 20.79,-76.17 58.55,-15.81 63.11,247.5 -0.69,231.18 -20.13,-5.15 -24.09,-17.31 -22.95,-36.89 0.66,-11.4 3.05,-25.32 4.98,-41.82 3.4,-29.04 0.62,-47.84 -2.14,-76.29z";

const styles = `
  @keyframes fadeUp  { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  @keyframes slideIn { from{opacity:0;transform:translateX(16px)} to{opacity:1;transform:translateX(0)} }
  @keyframes slideDown { from{opacity:0;max-height:0;transform:translateY(-8px)} to{opacity:1;max-height:80px;transform:translateY(0)} }

  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }

  .in-root {
    height:100vh; overflow:hidden;
    display:flex; flex-direction:column;
    font-family:'Inter',sans-serif; color:#0A0A1A;
    background:
      radial-gradient(ellipse 110% 70% at 70% -15%, rgba(26,106,255,0.09) 0%, transparent 55%),
      radial-gradient(ellipse 60% 50% at 5% 100%, rgba(6,182,212,0.05) 0%, transparent 50%),
      #F2F5FF;
    position:relative;
  }
  .in-root::before {
    content:''; position:absolute; inset:0; z-index:0; pointer-events:none;
    background-image:radial-gradient(circle, rgba(26,106,255,0.06) 1px, transparent 1px);
    background-size:44px 44px;
    mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black 20%, transparent 75%);
    -webkit-mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black 20%, transparent 75%);
  }

  .in-header {
    position:relative; z-index:2; flex-shrink:0;
    height:60px; padding:0 40px;
    display:flex; align-items:center; justify-content:space-between;
    background:#050C1A;
  }
  .in-wordmark { font-family:'Space Grotesk',sans-serif; font-size:11px; font-weight:600; letter-spacing:0.18em; text-transform:uppercase; color:rgba(255,255,255,0.4); display:flex; align-items:center; gap:10px; }
  .in-header-pill { font-size:9px; font-weight:600; letter-spacing:0.18em; text-transform:uppercase; color:rgba(255,255,255,0.3); padding:5px 12px; border:1px solid rgba(255,255,255,0.1); border-radius:20px; }

  .in-grid {
    flex:1; position:relative; z-index:1;
    display:grid; grid-template-columns:1fr 360px; gap:40px;
    max-width:1140px; width:100%; margin:0 auto; padding:0 40px;
    align-items:center; overflow:hidden;
  }

  .in-left { padding-right:40px; animation:fadeUp 0.6s ease forwards; }

  .in-pre-label { font-size:10px; font-weight:600; letter-spacing:0.22em; text-transform:uppercase; color:#06B6D4; margin-bottom:16px; display:flex; align-items:center; gap:10px; }
  .in-pre-label::before { content:''; width:18px; height:1.5px; background:#06B6D4; flex-shrink:0; border-radius:1px; }

  .in-headline { font-family:'Space Grotesk',sans-serif; font-size:clamp(36px,4.2vw,60px); font-weight:700; letter-spacing:-0.045em; line-height:0.97; color:#0A0A1A; margin-bottom:18px; }
  .in-headline-accent { color:#1A6AFF; }
  .in-sub { font-size:15px; font-weight:300; line-height:1.75; color:#6B7280; margin-bottom:24px; max-width:460px; }

  .in-field { position:relative; margin-bottom:10px; }
  .in-textarea { width:100%; min-height:110px; background:#FFFFFF; border:1.5px solid #E2E8F0; border-radius:12px; padding:16px 18px 32px; font-family:'Inter',sans-serif; font-size:15px; color:#0A0A1A; line-height:1.65; resize:none; outline:none; transition:border-color 0.2s, box-shadow 0.2s; caret-color:#1A6AFF; box-shadow:0 1px 3px rgba(0,0,0,0.05); }
  .in-textarea::placeholder { color:#9CA3AF; font-style:italic; }
  .in-textarea:focus { border-color:#1A6AFF; box-shadow:0 0 0 4px rgba(26,106,255,0.08); }
  .in-char { position:absolute; bottom:11px; right:14px; font-size:10px; font-weight:500; color:#9CA3AF; }

  /* Name field */
  .in-name-field {
    margin-bottom:10px;
    animation:slideDown 0.35s cubic-bezier(0.22,1,0.36,1) forwards;
    overflow:hidden;
  }
  .in-name-label { font-size:11px; font-weight:600; letter-spacing:0.1em; text-transform:uppercase; color:#6B7280; margin-bottom:6px; display:flex; align-items:center; gap:8px; }
  .in-name-label span { font-size:10px; font-weight:400; letter-spacing:0; text-transform:none; color:#9CA3AF; }
  .in-name-input { width:100%; height:44px; background:#FFFFFF; border:1.5px solid #E2E8F0; border-radius:10px; padding:0 16px; font-family:'Space Grotesk',sans-serif; font-size:15px; font-weight:600; color:#0A0A1A; outline:none; transition:border-color 0.2s, box-shadow 0.2s; caret-color:#1A6AFF; letter-spacing:0.01em; }
  .in-name-input::placeholder { color:#CBD5E1; font-weight:400; font-family:'Inter',sans-serif; font-size:14px; letter-spacing:0; }
  .in-name-input:focus { border-color:#1A6AFF; box-shadow:0 0 0 4px rgba(26,106,255,0.08); }
  .in-name-hint { font-size:11px; color:#9CA3AF; margin-top:5px; line-height:1.5; }
  .in-name-hint strong { color:#1A6AFF; font-weight:500; }

  .in-quality { height:28px; margin-bottom:14px; display:flex; align-items:center; gap:12px; opacity:0; transition:opacity 0.4s; }
  .in-quality.visible { opacity:1; }
  .in-q-track { flex:1; height:2px; background:#E2E8F0; border-radius:2px; overflow:hidden; }
  .in-q-fill { height:100%; border-radius:2px; transition:width 0.6s cubic-bezier(0.22,1,0.36,1); }
  .in-q-label { font-size:10px; font-weight:600; letter-spacing:0.1em; text-transform:uppercase; color:#6B7280; white-space:nowrap; min-width:96px; text-align:right; transition:color 0.4s; }
  .in-q-label.strong { color:#1A6AFF; }

  .in-btn { width:100%; height:52px; background:linear-gradient(135deg,#094BCC 0%,#1A6AFF 100%); border:none; border-radius:10px; font-family:'Space Grotesk',sans-serif; font-size:14px; font-weight:600; color:#fff; cursor:pointer; letter-spacing:0.03em; transition:all 0.2s; display:flex; align-items:center; justify-content:center; gap:10px; position:relative; overflow:hidden; box-shadow:0 4px 14px rgba(26,106,255,0.35); margin-bottom:16px; }
  .in-btn::after { content:''; position:absolute; inset:0; background:linear-gradient(135deg,rgba(255,255,255,0.1),transparent); opacity:0; transition:opacity 0.2s; }
  .in-btn:hover::after { opacity:1; }
  .in-btn:hover { transform:translateY(-1px); box-shadow:0 8px 24px rgba(26,106,255,0.4); }
  .in-btn:disabled { opacity:0.35; cursor:not-allowed; transform:none; box-shadow:none; }
  .in-btn-arrow { font-size:17px; transition:transform 0.2s; }
  .in-btn:hover .in-btn-arrow { transform:translateX(4px); }

  .in-trust { display:flex; align-items:center; gap:16px; flex-wrap:wrap; }
  .in-trust-item { font-size:10px; font-weight:500; letter-spacing:0.08em; text-transform:uppercase; color:#9CA3AF; display:flex; align-items:center; gap:5px; }
  .in-trust-dot { width:3px; height:3px; border-radius:50%; background:#06B6D4; flex-shrink:0; }

  .in-right { animation:slideIn 0.6s ease 0.15s forwards; opacity:0; animation-fill-mode:forwards; height:100%; display:flex; align-items:center; }
  .in-panel { width:100%; background:#FFFFFF; border:1px solid #E2E8F0; border-radius:16px; padding:22px 18px; position:relative; overflow:hidden; box-shadow:0 4px 20px rgba(0,0,0,0.06); }
  .in-panel::before { content:''; position:absolute; top:0; left:0; right:0; height:2px; background:linear-gradient(90deg, transparent, #1A6AFF 30%, #06B6D4 70%, transparent); }
  .in-panel-title { font-size:9px; font-weight:600; letter-spacing:0.2em; text-transform:uppercase; color:#9CA3AF; margin-bottom:6px; display:flex; align-items:center; gap:8px; }
  .in-panel-title::after { content:''; flex:1; height:1px; background:#F3F4F6; }
  .in-panel-status { font-size:10px; font-weight:600; letter-spacing:0.1em; text-transform:uppercase; height:28px; display:flex; align-items:center; color:#9CA3AF; margin-bottom:12px; transition:color 0.4s; }
  .in-panel-status.active { color:#1A6AFF; }
  .in-ph { display:flex; align-items:center; gap:10px; padding:7px 8px; border-radius:7px; margin-bottom:3px; border:1px solid transparent; transition:all 0.45s cubic-bezier(0.22,1,0.36,1); }
  .in-ph.locked { opacity:0.3; }
  .in-ph.unlocked { background:#EFF4FF; border-color:#BFDBFE; opacity:1; }
  .in-ph-num { font-size:9px; font-weight:600; letter-spacing:0.06em; color:#9CA3AF; width:18px; flex-shrink:0; transition:color 0.4s; }
  .in-ph.unlocked .in-ph-num { color:#1A6AFF; }
  .in-ph-name { font-size:11px; font-weight:400; color:#6B7280; transition:color 0.4s; }
  .in-ph.unlocked .in-ph-name { color:#0A0A1A; font-weight:500; }
  .in-ph-dot { width:5px; height:5px; border-radius:50%; background:#E2E8F0; margin-left:auto; flex-shrink:0; transition:all 0.4s; }
  .in-ph.unlocked .in-ph-dot { background:#1A6AFF; box-shadow:0 0 5px rgba(26,106,255,0.5); }
  .in-panel-footer { margin-top:12px; padding-top:12px; border-top:1px solid #F3F4F6; font-size:10px; font-weight:400; color:#9CA3AF; line-height:1.55; text-align:center; }

  .in-error { background:#FEF2F2; border:1px solid #FECACA; border-radius:10px; padding:12px 16px; font-size:13px; color:#DC2626; margin-bottom:14px; }

  @media (max-width:860px) {
    .in-grid { grid-template-columns:1fr; padding:0 20px; gap:24px; }
    .in-right { display:none; }
    .in-left { padding-right:0; }
    .in-header { padding:0 20px; }
    .in-wordmark { font-size:10px; gap:8px; flex-shrink:0; min-width:0; }
    .in-wordmark svg { flex-shrink:0; }
  }

  @media (max-width:600px) {
    .in-header { height:52px; padding:0 14px; overflow:hidden; }
    .in-wordmark { font-size:9px; letter-spacing:0.1em; }
    .in-grid { padding:0 16px; }
    .in-headline { font-size:clamp(28px,8vw,48px); }
    .in-sub { font-size:14px; }
    .in-textarea { font-size:14px; min-height:90px; }
    .in-submit-row { flex-direction:column; }
    .in-submit-row > * { width:100%; }
  }

  @media (max-width:400px) {
    .in-headline { font-size:26px; }
    .in-pre-label { font-size:9px; }
  }
`;

export default function Intake({ onGenerate, error, session, onDashboard, onSignOut }) {
  const [brief, setBrief] = useState('');
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(false);

  const analysis = analyzeBrief(brief);
  const isReady = brief.trim().length >= 10 && !loading;
  const hasName = userName.trim().length > 0;

  const handleSubmit = async () => {
    if (!isReady) return;
    setLoading(true);
    await onGenerate(brief.trim(), hasName ? userName.trim() : null);
    setLoading(false);
  };

  const handleKey = e => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) handleSubmit(); };

  const statusText = analysis.phasesLit === 10
    ? '10 / 10 phases ready'
    : analysis.phasesLit > 0
    ? `${analysis.phasesLit} / 10 phases unlocking`
    : 'Begin writing to unlock phases';

  const btnLabel = loading
    ? (hasName ? 'Assessing your brand...' : 'Preparing your brand...')
    : (hasName ? `Assess and Build ${userName.trim()}` : 'Build My Brand');

  const planColor = { pro:'#06B6D4', studio:'#1A6AFF', discover:'#8B5CF6' };
  const planLabel = { pro:'Brand Pro', studio:'Brand Studio', discover:'Discover' };
  const displayName = session?.name?.split(' ')[0] || (session?.email ? session.email.split('@')[0] : null);

  return (
    <>
      <style>{styles}</style>
      <div className="in-root">
        <div className="in-header">
          <div className="in-wordmark">
            <svg width="20" height="20" viewBox="1100 380 950 1300" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink:0 }}>
              <path fill="rgba(255,255,255,0.6)" d={LOGO_PATH} />
            </svg>
            Brandostro
          </div>

          {/* Nav right — session aware */}
          <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
            {session && displayName && (
              <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.35)', fontFamily:"'Inter',sans-serif" }}>
                {displayName}
              </div>
            )}
            {session && !displayName && session.email && (
              <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.35)', fontFamily:"'Inter',sans-serif" }}>
                {session.email.split('@')[0]}
              </div>
            )}
            {session?.plan && planLabel[session.plan] && (
              <div style={{ fontSize:'9px', fontWeight:'700', letterSpacing:'0.12em', textTransform:'uppercase', color: planColor[session.plan] || '#9CA3AF', padding:'4px 10px', border:`1px solid ${planColor[session.plan] || '#9CA3AF'}50`, borderRadius:'20px' }}>
                {planLabel[session.plan]}
              </div>
            )}
            {session && onDashboard && (
              <button
                onClick={onDashboard}
                style={{ fontSize:'11px', fontWeight:'600', color:'rgba(255,255,255,0.7)', background:'transparent', border:'1px solid rgba(255,255,255,0.2)', borderRadius:'8px', padding:'6px 16px', cursor:'pointer', fontFamily:"'Space Grotesk',sans-serif", letterSpacing:'0.04em' }}
              >
                Dashboard
              </button>
            )}
            {!session && (
              <div className="in-header-pill">Brand Intelligence Platform</div>
            )}
          </div>
        </div>

        <div className="in-grid">
          <div className="in-left">
            <div className="in-pre-label">Brand Intelligence Engine</div>
            <h1 className="in-headline">
              Describe your<br />
              business. <span className="in-headline-accent">Once.</span>
            </h1>
            <p className="in-sub">
              One sentence or ten. Brandostro builds your complete brand — strategy,
              name, identity, website, and launch plan — from what you write.
            </p>

            {error && <div className="in-error">{error}</div>}

            <div className="in-field">
              <textarea
                className="in-textarea"
                placeholder="Tell us what you're building. A sentence is enough. More is welcome."
                value={brief}
                onChange={e => setBrief(e.target.value)}
                onKeyDown={handleKey}
                maxLength={2000}
                disabled={loading}
                autoFocus
              />
              <span className="in-char">{brief.length} / 2000</span>
            </div>

            {/* Optional name field — always visible, never forced */}
            <div className="in-name-field">
              <div className="in-name-label">
                Brand Name <span>— optional</span>
              </div>
              <input
                className="in-name-input"
                placeholder="Already have a name? Enter it here..."
                value={userName}
                onChange={e => setUserName(e.target.value)}
                disabled={loading}
                maxLength={60}
              />
              {hasName && (
                <div className="in-name-hint">
                  We will <strong>professionally assess {userName.trim()}</strong> and build your full brand around it.
                  If we find stronger alternatives, we will show you why.
                </div>
              )}
            </div>

            <div className={`in-quality ${analysis.level >= 0 ? 'visible' : ''}`}>
              <div className="in-q-track">
                <div className="in-q-fill" style={{ width:`${analysis.bar}%`, background:analysis.color }} />
              </div>
              {analysis.level >= 0 && (
                <div className={`in-q-label ${analysis.level >= 2 ? 'strong' : ''}`}>{analysis.label}</div>
              )}
            </div>

            <button className="in-btn" onClick={handleSubmit} disabled={!isReady}>
              {btnLabel}
              {!loading && <span className="in-btn-arrow">→</span>}
            </button>

            <div className="in-trust">
              {['End-to-end encrypted','GDPR compliant','Never shared'].map((t,i) => (
                <div key={i} className="in-trust-item"><span className="in-trust-dot" />{t}</div>
              ))}
            </div>
          </div>

          <div className="in-right">
            <div className="in-panel">
              <div className="in-panel-title">What gets built</div>
              <div className={`in-panel-status ${analysis.phasesLit > 0 ? 'active' : ''}`}>{statusText}</div>
              {PHASES.map((name, i) => (
                <div key={i} className={`in-ph ${i < analysis.phasesLit ? 'unlocked' : 'locked'}`}>
                  <span className="in-ph-num">{String(i).padStart(2,'0')}</span>
                  <span className="in-ph-name">{name}</span>
                  <span className="in-ph-dot" />
                </div>
              ))}
              <div className="in-panel-footer">
                Built by the methodology of the world's greatest brand agencies.
                Available to every business. For the first time.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
